import { Anchor, List, ListItem, Paper, Text, Title } from "@mantine/core";
import { uploadSourcesCopy } from "../utils/merchantCopy";

export default function MerchantHelp({ marketplaceName }) {
  const dest = marketplaceName || "the marketplace";

  return (
    <Paper p="lg" withBorder mt="md">
      <Title order={4} mb="sm">
        How this works
      </Title>
      <List type="ordered" spacing="xs" size="sm">
        <ListItem>
          {uploadSourcesCopy()} We detect the file type.
        </ListItem>
        <ListItem>
          Review titles, attributes, and anything we could not fill.
        </ListItem>
        <ListItem>
          Download the file and upload it in your own {dest} back office.
        </ListItem>
      </List>
      {marketplaceName && (
        <Text size="sm" mt="md">
          Trial SKUs from {dest} only pay for {dest} listings. Paid SKUs work
          on any marketplace.
        </Text>
      )}
      <Text size="sm" c="dimmed" mt="md">
        You remain responsible for your listings. Optivise does not log into{" "}
        {dest} for you. Stuck?{" "}
        <Anchor href="mailto:support@optivise.io" size="sm">
          support@optivise.io
        </Anchor>
      </Text>
    </Paper>
  );
}
